import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Box, Button, Typography } from '@mui/material'
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined'
import { downloadDescriptionPdf, fetchFormCode, FORM_CODE_QUERY_KEY, pdfFileName } from '../api/descriptionPdf'
import { t } from '../i18n'

/**
 * s62 / "Baixar PDF" da descricao (modelo PES.001). Publicada = o documento oficial; rascunho = mesmo PDF com a marca
 * d'agua "RASCUNHO - NAO VALE COMO DOCUMENTO" (P2). O nome do arquivo segue o padrao do servidor.
 */
export function DescriptionPdfButton({
  descriptionId,
  jobCode,
  version,
  published,
}: {
  descriptionId: string
  jobCode: string
  version: number
  published: boolean
}) {
  const form = useQuery({ queryKey: FORM_CODE_QUERY_KEY, queryFn: fetchFormCode, retry: false })
  const [baixando, setBaixando] = useState(false)
  const [erro, setErro] = useState(false)
  async function baixar() {
    setBaixando(true)
    setErro(false)
    try {
      await downloadDescriptionPdf(descriptionId, pdfFileName(form.data?.formCode ?? 'PES.001', jobCode, version, published))
    } catch {
      setErro(true)
    } finally {
      setBaixando(false)
    }
  }
  return (
    <Box>
      <Button
        variant="outlined"
        size="small"
        startIcon={<PictureAsPdfOutlined fontSize="small" />}
        onClick={() => void baixar()}
        disabled={baixando}
        data-testid="baixar-pdf"
      >
        {baixando ? t.descriptionPdf.downloading : published ? t.descriptionPdf.download : t.descriptionPdf.downloadDraft}
      </Button>
      {erro && (
        <Typography variant="caption" color="error" component="p" role="alert">
          {t.descriptionPdf.error}
        </Typography>
      )}
    </Box>
  )
}
